import { create } from "./store";

type UIStoreState = {
  menuVisible: boolean;
  isMenuClosing: boolean;
};

type UIStoreActions = {
  showMenu: () => void;
  hideMenu: () => void;
  startMenuClosing: () => void;
  resetMenuState: () => void;
};

const initialState: UIStoreState = {
  menuVisible: false,
  isMenuClosing: false,
};

const uiStore = create<UIStoreState & UIStoreActions>()((set) => ({
  ...initialState,
  showMenu: () => set({ menuVisible: true, isMenuClosing: false }),
  hideMenu: () => set({ menuVisible: false, isMenuClosing: false }),
  startMenuClosing: () => set({ isMenuClosing: true }),
  resetMenuState: () => set({ menuVisible: false, isMenuClosing: false }),
}));

export default uiStore; 